module.exports = __webpack_public_path__ + "static/media/GenWizardPlatform.c5f835a4.png";